var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadingOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 10C3.22386 10 3 10.2239 3 10.5V16C3 16.5523 2.55228 17 2 17C1.44772 17 1 16.5523 1 16V2C1 1.44772 1.44772 1 2 1C2.55228 1 3 1.44772 3 2V7.5C3 7.77614 3.22386 8 3.5 8C3.77614 8 4 7.77614 4 7.5V2C4 0.895431 3.10457 0 2 0C0.895431 0 0 0.89543 0 2V16C0 17.1046 0.895431 18 2 18C3.10457 18 4 17.1046 4 16V10.5C4 10.2239 3.77614 10 3.5 10Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V10.5C13 10.2239 12.7761 10 12.5 10C12.2239 10 12 10.2239 12 10.5V16C12 17.1046 12.8954 18 14 18C15.1046 18 16 17.1046 16 16V2C16 0.895431 15.1046 0 14 0C12.8954 0 12 0.89543 12 2V7.5C12 7.77614 12.2239 8 12.5 8C12.7761 8 13 7.77614 13 7.5V2C13 1.44772 13.4477 1 14 1C14.5523 1 15 1.44772 15 2Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10H12H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H12H4H3.5C3.22386 11 3 10.7761 3 10.5C3 10.2239 3.22386 10 3.5 10H4ZM12.5 7C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H12H4H3.5C3.22386 8 3 7.77614 3 7.5C3 7.22386 3.22386 7 3.5 7H4H12H12.5Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingOutlinedIcon);
export default __webpack_public_path__ + "static/media/headingOutlinedIcon.f9273b37.svg";
export { ForwardRef as ReactComponent };